exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Weforsys-Text{padding:3px 0;margin:0}", ""]);

// exports
